import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useCurrentLanguage } from '@cp/shared/localization';
import { FormContext } from '@cp/utils/form/formContext';
import { SupportSendMessageFormModel, SupportSendMessageFormProps } from './model';
import { View } from './view';

export * from './model';

export const SupportSendMessageForm = ({ onSend, resolver }: SupportSendMessageFormProps) => {
  const languageCode = useCurrentLanguage();

  const form = useForm<SupportSendMessageFormModel, FormContext>({
    defaultValues: {
      name: '',
      email: '',
      message: '',
      attachments: null,
    },
    resolver,
    context: {
      languageCode,
    },
  });

  const handleSubmit: SubmitHandler<SupportSendMessageFormModel> = async (values) => {
    await onSend(values, form);
  };

  const viewProps = {
    form,
    onSubmit: handleSubmit,
  };

  return <View {...viewProps} />;
};
